export default "__VITE_ASSET__Dl1VnUnN__"